"use strict";

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];

  return to;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromReadonlyNonEmptyArray = exports.has = exports.isLeft = exports.isSome = void 0; // -------------------------------------------------------------------------------------
// Option
// -------------------------------------------------------------------------------------

/** @internal */

var isSome = function (fa) {
  return fa._tag === 'Some';
};

exports.isSome = isSome; // -------------------------------------------------------------------------------------
// Either
// -------------------------------------------------------------------------------------

/** @internal */

var isLeft = function (ma) {
  return ma._tag === 'Left';
};

exports.isLeft = isLeft; // -------------------------------------------------------------------------------------
// Record
// -------------------------------------------------------------------------------------

/** @internal */

exports.has = Object.prototype.hasOwnProperty; // -------------------------------------------------------------------------------------
// NonEmptyArray
// -------------------------------------------------------------------------------------

/** @internal */

var fromReadonlyNonEmptyArray = function (as) {
  return __spreadArray([as[0]], as.slice(1));
};

exports.fromReadonlyNonEmptyArray = fromReadonlyNonEmptyArray;